import Env from 'enviro';
const qa_prod = Env.getShort('user-preferences') === 'prod' ? '' : 'qa';
export const LOGIN_BASE_URL = `https://app.hubspot${qa_prod}.com/login`;
export const LOGOUT_API = `https://app.hubspot${qa_prod}.com/login-api/v1/logout/all`;
export const LOGOUT_ALL_DEVICES_API = `https://app.hubspot${qa_prod}.com/login-api/v1/logout/all-devices`;